import React, { useState } from 'react';
import { SpaceBetween, Box, Button, Popover, Pagination } from '@amzn/awsui-components-core';
import { Avatar, AvatarSize } from '@amzn/stencil-react-components/avatar';
import { EmployeePopoverCard } from './EmployeePopoverCard';
import { AttendeePriority } from '../../interfaces/interface';
import { PRIORITY_COLORS } from '../../constants/EAHuddleConstants';

const GROUP_MEMBERS_PAGE_SIZE = 10;

interface GroupMembersPopoverContentProps {
  members: string[];
  existingLogins: Set<string>;
  onAdd?: (login: string, priority: AttendeePriority) => void;
}

export const GroupMembersPopoverContent: React.FC<GroupMembersPopoverContentProps> = ({ members, existingLogins, onAdd }) => {
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(members.length / GROUP_MEMBERS_PAGE_SIZE);
  const paged = members.slice((page - 1) * GROUP_MEMBERS_PAGE_SIZE, page * GROUP_MEMBERS_PAGE_SIZE);

  return (
    <SpaceBetween direction="vertical" size="xs">
      <Box fontWeight="bold" fontSize="body-s">
        Members ({members.length})
      </Box>
      {paged.map((login) => {
        const isAlreadyAdded = existingLogins.has(login.toLowerCase());
        return (
          <div key={login} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <EmployeePopoverCard loginName={login} renderWithPortal>
              <Avatar username={login} size={AvatarSize.ExtraSmall} imageAltText={login} />
            </EmployeePopoverCard>
            <div style={{ marginLeft: 'auto' }}>
              {isAlreadyAdded ? (
                <span className="priority-badge added-badge">Added</span>
              ) : onAdd ? (
                <Popover
                  triggerType="custom"
                  position="bottom"
                  size="small"
                  dismissButton={false}
                  renderWithPortal
                  content={
                    <SpaceBetween direction="vertical" size="xxxs">
                      {([AttendeePriority.Critical, AttendeePriority.Required, AttendeePriority.Optional] as AttendeePriority[]).map((p) => (
                        <span
                          key={p}
                          className="priority-badge"
                          style={{ backgroundColor: PRIORITY_COLORS[p]?.background, color: PRIORITY_COLORS[p]?.color, cursor: 'pointer' }}
                          onClick={() => onAdd(login, p)}
                        >
                          {p.charAt(0).toUpperCase() + p.slice(1)}
                        </span>
                      ))}
                    </SpaceBetween>
                  }
                >
                  <Button variant="icon" iconName="add-plus" ariaLabel={`Add ${login}`} />
                </Popover>
              ) : null}
            </div>
          </div>
        );
      })}
      {totalPages > 1 && <Pagination currentPageIndex={page} pagesCount={totalPages} onChange={({ detail }) => setPage(detail.currentPageIndex)} />}
    </SpaceBetween>
  );
};
